<template>
<v-select ref="type" v-model="internalValue" :loading="loading" :items="items" item-text="title" item-value="value" v-bind="$attrs" v-on="$listeners"/>
</template>

<script>
export default {
  name: 'InvoiceType',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      internalValue: this.value,
      loading: false,
      items: [],
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
    internalValue(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    if (this.$refs.type) {
      this.$refs.type.focus()
    }
  },
  methods: {
    async retrieveData() {
      this.loading = true
      try {
        this.items = [{
            value: 'buy',
            title: 'خرید'
          },
          {
            value: 'sale',
            title: 'فروش'
          }
        ]
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  },
  created() {
    this.retrieveData()
  }
}
</script>
